<template>
  <v-card v-if="firm && mySurveys">
    <v-row wrap class="group ma-0 pa-2 py-10 pb-6">
      <v-icon class="drag-icon" size="18">icon-drag</v-icon>
      <v-col cols="12" md="6" align-self="center" class="mb-3 mb-sm-0">
        <IDCard
          :id="firm ? firm.id : null"
          :title="firm ? firm.title : null"
          :address="firm ? firm.address : null"
          :city="firm ? firm.city : null"
          :zip="firm ? firm.zip : null"
          :vat="firm ? firm.vat : null"
          :nr="firm ? firm.nr : null"
          :reg="firm ? firm.reg : null"
          reload
          @editFirmToParent="reloadFirm"
          class="d-block w-100"
        ></IDCard>
      </v-col>
      
      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="4" md="2" align-self="center">
        <div class="text-center">
          <h3 class="mb-3">{{ $t("progress-gauge.status") }}</h3>
          <ProgressGauge
            :size="70"
            :status="score >= maxScore &&
                    maxScore !== 0 ? 'sent' : 'new'"
            :score="parseInt(score)"
            :scoreRequired="parseInt(maxScore) == 0 ? 1 : parseInt(maxScore)"
          ></ProgressGauge>
        </div>
      </v-col>

      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="4" md="2" align-self="center">
        <div class="text-center">
          <v-btn
            color="primary"
            elevation="0"
            rounded
            small
            class="fetch"
            :to="{ name: 'create-audit', params: {firm: firm} }"
          >
            {{ $t('dashboard-screen.btn-1') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-expansion-panels
        v-model="panel"
        multiple
        accordion>
      <template v-for="survey in mySurveys">
        <transition name="fade" :key="survey.id" v-if="firm.id === survey.firmid">
          <AuditOverview
            :survey="survey"
            :firm="firm"
            class="dashboard-row"
            @deleteSurveyToParent="reloadSurvey"></AuditOverview>
        </transition>
      </template>
    </v-expansion-panels>

  </v-card>
</template>

<script>
import { showSequence } from '@/js/survey/showSequence'
import AuditOverview from '@/components/audits/AuditOverview'
import IDCard from '@/components/firm/IDCard'
import ProgressGauge from '@/components/progress/ProgressGauge'

export default {
  props: {
    firm: Object,
    mySurveys: Array
  },

  components: {
    AuditOverview: AuditOverview,
    IDCard: IDCard,
    ProgressGauge: ProgressGauge
  },

  data () {
    return {
      test: [],
      maxScore: 0,
      score: 0,
      panel: [0]
    }
  },

  methods: {
    reloadFirm () { this.$emit('reloadFirmList') },
    reloadSurvey () { this.$emit('reloadSurveyList') }
  },

  created () {
    this.mySurveys.forEach(survey => {
      if (survey.firmid === this.firm.id) {
        this.maxScore += 2
        this.score += survey.status === 'new' ? 1 : 2
      }
    })
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@import '../../styles/components/audits/group-overview';

</style>
